<div
  class="login"
  fxFlexAlign="center"
  fxFlex="0 1 calc(32px + 32em)"
  fxFlexAlign="start"
>
  <form (submit)="tryLogin()">
    <mat-card>
      <mat-card-title>Login</mat-card-title>
      <div *ngIf="!working; else loading">
        <mat-card-content>
          <mat-form-field class="full">
            <input
              matInput
              placeholder="Email"
              name="email"
              [(ngModel)]="email"
            />
          </mat-form-field>
          <mat-form-field class="full">
            <input
              matInput
              placeholder="Password"
              name="password"
              [(ngModel)]="password"
              type="password"
            />
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions>
          <button type="button" mat-flat-button (click)="forgot()">
            Forgot Password
          </button>
          <button type="submit" mat-flat-button color="accent">Login</button>
        </mat-card-actions>
      </div>
      <ng-template #loading>
        <mat-spinner></mat-spinner>
      </ng-template>
    </mat-card>
  </form>
</div>
